import "./Landing.css";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import * as pbi from "powerbi-client";
import "../PowerBI/powerBi.css";
import { apiHelper } from "../lib/ApiHelper";
import { useEffect, useState } from "react";
const pbiUrl = 'https://app.powerbi.com/reportEmbed?';
const pbiConfigUrl = '&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QyLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZSwiZGlzYWJsZUFuZ3VsYXJKU0Jvb3RzdHJhcFJlcG9ydEVtYmVkIjp0cnVlfX0%3d';

export default function Dashboard(props) {
    const [loading, setLoading] = useState(true);
    const models = pbi.models;
   // const reportId = "a702a54e-844e-483d-822a-8bf0cafc8048";
    const pbiConfig = {
        type: 'report',   // Supported types: report, dashboard, tile, visual and qna
        tokenType: models.TokenType.Aad,
        accessToken: props.token,
        embedUrl: `${pbiUrl}reportId=${props.reportId}${pbiConfigUrl}`,
        permissions: models.Permissions.Read.All,
      // id: 'bcb763b7-60c6-4a25-98eb-e9972e225735',
        id: props.reportId,
        settings: {
            layoutType: models.LayoutType.Custom,
            customLayout: {
                displayOption: models.DisplayOption.FitToPage
            },
            panes: {
                filters: {
                    expanded: false,
                    visible: true
                },
                pageNavigation: {
                    visible: false
                },
            },
        }
        //, filters: [
        //    {
        //        $schema: "http://powerbi.com/product/schema#basic",
        //        target: {
        //            table: "inventoryhub V004_HubDashboard",
        //            column: "Owner Name"
        //        },
        //        operator: props?.upn && props?.upn != "" ? "In" : "All",
        //        values: ['Andrea Cerini'],//props?.upn ? [props?.upn]:[],
        //        filterType: models.FilterType.BasicFilter
        //        //requireSingleSelection: false
        //    },
        //]
        //,filters: [
        //    {
        //        $schema: "http://powerbi.com/product/schema#hierarchy",
        //        target: [{
        //            table: "inventoryhub V004_HubDashboard",
        //            hierarchy: "Owner Name",
        //            hierarchyLevel: "Owner Name"
        //        }],
        //        //operator: props?.upn && props?.upn != "" ? "In" : "All",
        //        //values: props?.upn ? [props?.upn]:[],
        //        // values: props?.upn ? [props?.upn]:[],
        //        "hierarchyData": [
        //            {
        //                "operator": "Selected",
        //                "value": 'Andrea Cerini'
        //            }],
        //        filterType: models.FilterType.HierarchyFilter,
        //        requireSingleSelection: false
        //    },
        //]


    };
  
    function splitCSVLine(line) {
        const regex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;
        const parts = line.split(regex).map(value => {
            return value.replace(/^"|"$/g, '').trim();
        });
        return parts;
    }
  
    const handleVisualClicked = async (event) => {
        try {
            const actionButtonTitle = 'View ISBN';
            const embedContainer = document.getElementsByClassName("invHubDashboard")[0];
            const report = await powerbi.get(embedContainer);
            const pages = await report.getPages();
            if (pages?.length == 0) { console.warn(`There are no pages on the report`); return; }
            const visuals = (await pages[0].getVisuals())?.filter(r => r.type.toLowerCase() == 'actionbutton' && r.title.toLowerCase() == actionButtonTitle.toLowerCase()) ?? [];
            if (visuals.length == 0) { console.warn(`There is no button with title ${actionButtonTitle}`); return; }
            if (visuals[0].name.toLowerCase() != event.detail.visual.name.toLowerCase()) { return; }
            const isbnList = await getTitleDashboardISBNList();
          //  const shouldReplace = true;
           /* const prepend = false;
            const formOverview = false;
            const updateSetTitle = true;
           await apiHelper.ISBNCheck(isbnList, props.upn, props.setIsbnData, props.isbnData, prepend, formOverview, updateSetTitle);*/
            //  await apiHelper.checkForDup(isbnList, props.upn, props.isbnData, props.setIsbnData, shouldReplace);
            const deletePRevData = true;
            await apiHelper.inventoryPostCall("setTitleList", {
                isbnList: isbnList,
                upn: props.upn,
                flag: deletePRevData
            })
           window.location.href = "/overview";
        } catch ({ name, message }) {
            console.info(`%cERROR: pbi visual clicked error: ${name} -> ${message}`, 'background: #D2042D; color: #ffffff');
        }
    }

    const clearISBN = async() => {

        props.setIsbnData({
            listISBN: [],
            Loading: false,
            duplicates: [],
            invalid: []
        });
        props.setISBNId('');
        // await apiHelper.handleReplaceList([], props.upn, true);
    }
    const handleReportLoaded = async (event)=>{
        var embedContainer = document.getElementsByClassName("invHubDashboard")[0];
        var report = await powerbi.get(embedContainer);
        var filters = [{
                $schema: "http://powerbi.com/product/schema#advanced",
                target: {
                    table: "inventoryhub V004_HubDashboard",
                    column: "Owner UPN"
                },
                operator: props?.upn && props?.upn != "" ? "Selected" : "All",
                values: props?.upn ? [props?.upn]:[],
                filterType: models.FilterType.AdvancedFilter
        }];
        var slicerState = {
            $schema: "http://powerbi.com/product/schema#slicer",
            filters: [
                {
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                        table: "inventoryhub V004_HubDashboard", // Replace with your table name
                        column: "Owner UPN" // Replace with the slicer column name
                    },
                    operator: "In",
                    values: props?.upn ? [props?.upn] : []// Replace with the value you want to pre-select
                }
            ]
        };

        report.getActivePage().then(function (page) {
            page.getVisuals().then(function (visuals) {
                visuals.forEach(function (visual) {
                    if (visual.type === "slicer") {
                        visual.setSlicerState(slicerState).then(function () {
                            console.log("Slicer state applied");
                        }).catch(function (errors) {
                            console.log(errors);
                        });
                    }
                });
            });
        });

    }

    const getTitleDashboardISBNList = async (report) => {        
        let isbnList = [];
        console.info('Loading...');
        try {            
            var embedContainer = document.getElementsByClassName("invHubDashboard")[0];
            var report = await powerbi.get(embedContainer);
            let pages = await report.getPages();
            if (pages?.length == 0) { return isbnList; }            
            const visuals = (await pages[0].getVisuals())?.filter(r => r.title.toLowerCase() == 'title dashboard' || r.title.toLowerCase() == 'title list') ?? [];
            if (visuals?.length == 0) { return ''; }
            const data = (await visuals[0].exportData(models.ExportDataType.Summarized))?.data ?? null;
            if (!data) { return isbnList; }
            const lines = data.split("\r\n");
            const headers = lines[0].split(",");
            const isbnIndex = headers.findIndex(item => item.toLowerCase().trim() == 'isbn') ?? 0;
            for (var i = 1; i < lines.length; i++) {
                const currentline = splitCSVLine(lines[i]);
                const isbn = currentline[isbnIndex]?.trim() ?? '';
                if (isbn?.length > 0) {
                    isbnList.push(isbn);
                }
            }
        } catch ({ name, message }) {
            console.warn('Failed to get isbnlist from pbi report with error', name, message);
        }
        finally {
            console.info('completed.');
        }
        return isbnList;
    }

    useEffect(() => {
      
        if (!loading && props.audience != "US" && props.audience != "DK") {
       
            window.location.href = "/overview";
        }
        setLoading(false);  
    }, [props.audience])
    return (
        <>
            {props.token === '' || props.reportId ==='' ? <>Loading...</> :
                <PowerBIEmbed
                    embedConfig={pbiConfig}
                    eventHandlers={
                        new Map([
                            ['loaded', (event) => handleReportLoaded(event)],
                            ['visualClicked', (event) => handleVisualClicked(event)],
                        ])}
                    cssClassName={"Embed-container dboard invHubDashboard"}
                />}

        </>
    )
}